import React from 'react'
import boomColouredIcon from "../../assets/boom_coloured.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";


export default function MyProduct({product,products,setProducts}) {
  return (
    <div className="my-2" key={product.id}>
    <button
      type="button"
      className={`btn w-100 h-100 bg-white p-3 text-start rounded-3 position-relative ${
        products.includes(product.id)
          ? "border border-2 border-blue"
          : ""
      }`}
      onClick={() => {
        if (products.includes(product.id)) {
          setProducts((p) => p.filter((pr) => pr !== product.id));
        } else {
          setProducts((p) => [...p, product.id]);
        }
      }}
    >
      {products.includes(product.id) ? (
        <FontAwesomeIcon
          icon={faCheck}
          className="position-absolute top-0 end-0 text-white bg-colored p-2"
          style={{ borderBottomLeftRadius: 8 }}
        />
      ) : null}
      <div className="d-flex align-items-center">
        <div className="bg-purple-gradient rounded-circle me-3">
          <img src={boomColouredIcon} width={50} alt='icon'/>
        </div>
        <div className="me-3">
          <h5 className="text-blue fw-bold">{product.title}</h5>
          <div className="text-secondary small">
            {product.description}
          </div>
        </div>
        <div>
          <span className="fw-bold ">
            Price:
            <span className="text-blue text-nowrap fs-5 ">
              £{product.price}/month
            </span>
          </span>
        </div>
      </div>
    </button>
  </div> )
}
